// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__P9IfG","right":"Footer_right__3Wi3v","buttons":"Footer_buttons__19Lk5"};